module.exports = __webpack_public_path__ + "img/dashtech-alt-logo.e2bfc2d9.svg";